<template>
  <div class="addOrgaManager-coantainer">
    <base-dialog
      :model="addManagerData.isOpen"
      title="添加管理员"
      @close="handleClose"
    >
      <template #body>
        <el-form ref="managerForm" :model="formData" :rules="rules" label-width="150px">
          <el-form-item label="管理员账号" prop="username">
            <el-input  v-model.trim="formData.username" ></el-input>
          </el-form-item>
          <el-form-item label="管理员名称" prop="realName">
            <el-input  v-model.trim="formData.realName" ></el-input>
          </el-form-item>
          <el-form-item label="管理员手机号" prop="phone">
            <el-input  v-model.trim="formData.phone" ></el-input>
          </el-form-item>
          <el-form-item label="寓家账号" prop="externalAccount">
            <el-input v-model.trim="formData.externalAccount"></el-input>
          </el-form-item>
          <el-form-item label="寓家密码" prop="externalPassword">
            <el-input v-model.trim="formData.externalPassword" type="password" show-password></el-input>
          </el-form-item>
          <el-form-item label="管理楼栋" prop="buildIdList" >
             <el-select
                v-model="formData.buildIdList"
                multiple
                placeholder="请选择绑定楼栋">
                <el-option
                  v-for="item in towerList"
                  :key="item.id"
                  :label="item.buildName"
                  :value="item.id">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input v-model.trim="formData.remarks"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <template #footer>
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="saveOrgaManagerFn">确 定</el-button>
      </template>
    </base-dialog>
  </div>
</template>

<script>
import { saveOrgaManager, getAllOrgaBuildByOrgaId } from '@/api/orga'

export default {
  props: {
    addManagerData: {
      type: Object
    }
  },
  data () {
    return {
      towerList: [],
      formData: {
        buildIdList: [],
        username: '',
        realName: '',
        remarks: '',
        phone: '',
        externalAccount: '',
        externalPassword: ''
      },
      rules: {
        username: [
          { required: true, message: '管理员账号', trigger: 'blur' }
        ]
        // phone: [
        //   { required: true, message: '手机号码不能为空', trigger: 'blur' }
        // ]
      }
    }
  },
  watch: {
    'addManagerData.isOpen': function () {
      this.getOrgaTower()
      this.$nextTick(() => {
        this.$refs.managerForm.resetFields()
         console.log('重设', this.formData)
      })
    }
  },
  methods: {
    /* 添加管理员 */
    saveOrgaManagerFn () {
      this.$refs.managerForm.validate((valid) => {
        if (valid) {
          const data = JSON.parse(JSON.stringify(this.formData))
          data.orgaId = this.addManagerData.orgaId
          saveOrgaManager(data).then(r1 => {
            this.$refs.managerForm.resetFields()
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
                this.$emit('successHandle')
                this.handleClose()
          })
        }
      })
    },
    // 获取组织楼栋
    getOrgaTower () {
      console.log('楼栋！！', this.addManagerData)
      getAllOrgaBuildByOrgaId(this.addManagerData.orgaId).then((res) => {
        this.towerList = res.data
      })
    },
    /* 关闭弹窗 */
    handleClose () {
      this.addManagerData.isOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
